import { css } from "@emotion/css";
import { ExclamationCircleIcon, ExclamationTriangleIcon, GemIcon } from "@octopusdeploy/design-system-icons";
import { space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
import * as React from "react";
export const inlineMessageTypes = ["information", "warning", "danger", "feature"] as const;
export type InlineMessageType = (typeof inlineMessageTypes)[number];
interface ActionProps {
    label: string;
    onClick?: () => void;
}
export interface InlineMessageProps {
    type: InlineMessageType;
    title?: string;
    description: string;
    action?: ActionProps;
}
export const InlineMessage = (props: InlineMessageProps) => {
    const { type, title, description, action } = props;
    const iconElement = getIconForType(type);
    return (<div className={containerStyles}>
            {iconElement}
            <span className={titleStyles}>{title}</span>
            {description && <span className={messageStyles}>{description}</span>}
            {action?.onClick && (<button className={buttonStyles} onClick={action.onClick}>
                    {action.label}
                </button>)}
        </div>);
};
InlineMessage.displayName = "InlineMessage";
const iconsByType: Record<InlineMessageType, React.ReactElement> = {
    information: <ExclamationCircleIcon size={20} color={themeTokens.color.icon.info}/>,
    warning: <ExclamationCircleIcon size={20} color={themeTokens.color.icon.warning}/>,
    danger: <ExclamationTriangleIcon size={20} color={themeTokens.color.icon.danger}/>,
    feature: <GemIcon size={20} color={themeTokens.color.icon.feature}/>,
};
function getIconForType(type: InlineMessageType): React.ReactNode {
    return iconsByType[type] || null;
}
const containerStyles = css({
    display: "flex",
    alignItems: "flex-start",
    gap: space[4],
    flexWrap: "wrap",
});
const titleStyles = css({
    font: text.body.bold.medium,
    color: themeTokens.color.text.primary,
});
const messageStyles = css({
    font: text.body.regular.medium,
    color: themeTokens.color.text.primary,
});
const buttonStyles = css({
    font: text.body.regular.medium,
    color: themeTokens.color.text.link.default,
    background: "none",
    padding: "0",
    border: "none",
    cursor: "pointer",
    "&:hover": {
        textDecoration: "underline",
    },
});
